import React from 'react';
import {Body} from '@lightricks/react-design-system';
import type {Post} from '@/types/post';
import type {OffPlatformPost} from '@/api/fetchers/crm/offPlatformCreators';
import IdentityPost from '@/components/identity-post';
import IframelyEmbed from './IframelyEmbed';
import styles from './OffPlatformProfile.module.scss';

function toIdentityPost(post: OffPlatformPost): Post {
  return {
    id: post.id,
    cachedAccountFollowerCount: 0,
    commentCount: post.comments ?? null,
    impressionCount: post.views ?? null,
    likeCount: post.likes ?? null,
    viewCount: post.views ?? null,
    networkUrl: post.url,
    shareCount: null,
    tags: [],
    createdAt: post.created ?? '',
    imageUrl: post.thumbnail ?? null,
    body: post.text ?? null,
    createdAtDay: '',
    createdAtMonth: '',
    createdAtWeek: '',
    isPaid: false,
    socialStream: 'feed',
  };
}

export default function OffPlatformPostGrid({
  posts,
  emptyLabel = 'No posts in the stored snapshot.',
}: {
  posts: OffPlatformPost[];
  emptyLabel?: string;
}) {
  if (posts.length === 0) {
    return <Body size="md">{emptyLabel}</Body>;
  }

  return (
    <div className={styles.postGrid}>
      {posts.map((post) =>
        post.thumbnail ? (
          <IdentityPost key={post.id} post={toIdentityPost(post)} />
        ) : (
          <div className={styles.embedCard} key={post.id}>
            {post.text ? <Body size="md">{post.text}</Body> : null}
            <IframelyEmbed url={post.url} />
          </div>
        )
      )}
    </div>
  );
}
